export default {
  SET_YEAR_LIST (state, list) {
    state.list = list
  },
  SET_YEAR_SELECTED (state, year) {
    state.selected = year
  }
}
